// Institute of Design and Innovation (email idi@unm.edu). //

import authService from '@/common/authService'
import permissions from '@/models/permissions'
import store from '../store/store'

/**
 * Directive to hide/show an element based on a user's permissions
 * @param el The element that the directive is bound to
 * @param bindings Arguments
 */
export function hasPermissionDirective (el: HTMLElement, bindings) {
  const requiredPermission = bindings.value
  const hasPermission = authService.authorize(store.getters.permissionValue, requiredPermission)

  if (!hasPermission) {
    el.style.display = 'none'
  } else {
    el.style.removeProperty('display')
  }
}

/**
 * Directive to hide/show an element if user is admin
 * @param el the html element that the directive is bound to
 */
export function isAdminDirective (el: HTMLElement) {
  const hasPermission = authService.authorize(store.getters.permissionValue, permissions.canManageSystem)

  if (!hasPermission) {
    el.style.display = 'none'
  } else {
    el.style.removeProperty('display')
  }
}
